import { render, staticRenderFns } from "./AtualizarItemCarrinho.vue?vue&type=template&id=70f11fa8"
import script from "./AtualizarItemCarrinho.vue?vue&type=script&lang=js"
export * from "./AtualizarItemCarrinho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports